"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = require("debug")("fifi:appService");

var Applications = function () {
  function Applications(appConfig, $http, $q) {
    "ngInject";

    _classCallCheck(this, Applications);

    this._appConfig = appConfig;
    this._$http = $http;
    this._$q = $q;
  }

  _createClass(Applications, [{
    key: "query",
    value: function query(config) {
      var request = {
        url: this._appConfig.api + "/applications",
        method: "GET"
      };

      if (config && (config.type || config.year)) {
        if (!config.type) {
          Reflect.deleteProperty(config, "type");
        }
        if (!config.year) {
          Reflect.deleteProperty(config, "year");
        }
        request.params = config;
      }

      if (config && config.id) {
        request.url = this._appConfig.api + "/applications/" + config.id;
      }

      debug(request);
      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "save",
    value: function save(application) {
      var request = {};

      if (application._id) {
        request.url = this._appConfig.api + "/applications/" + application._id;
        request.method = "PUT";
      } else {
        request.url = this._appConfig.api + "/applications";
        request.method = "POST";
      }

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "manual",
    value: function manual(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/manual";
      request.method = "POST";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "note",
    value: function note(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/note";
      request.method = "POST";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "wait",
    value: function wait(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/wait";
      request.method = "POST";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "mailingList",
    value: function mailingList(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/mailingList";
      request.method = "POST";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "payAndAccept",
    value: function payAndAccept(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/pay/" + application._id;
      request.method = "PUT";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "acceptSpecial",
    value: function acceptSpecial(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/special/" + application._id;
      request.method = "PUT";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "refund",
    value: function refund(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/refund/" + application._id;
      request.method = "PUT";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "capture",
    value: function capture(application) {
      var request = {};

      request.url = this._appConfig.api + "/applications/accept/" + application._id;
      request.method = "PUT";

      request.data = application;

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "stats",
    value: function stats() {
      var request = {
        url: this._appConfig.api + "/applications/stats",
        method: "GET"
      };
      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "report",
    value: function report(config) {
      var request = {
        url: this._appConfig.api + "/applications/report",
        method: "GET"
      };

      if (config && (config.type || config.year)) {
        if (!config.type) {
          Reflect.deleteProperty(config, "type");
        }
        if (!config.year) {
          Reflect.deleteProperty(config, "year");
        }
        request.params = config;
      }

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "homeowner",
    value: function homeowner(config) {
      var request = {
        url: this._appConfig.api + "/applications/homeowner",
        method: "GET"
      };

      if (config) {
        request.params = config;
      }

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "stickers",
    value: function stickers(config) {
      var request = {
        url: this._appConfig.api + "/applications/stickers",
        method: "GET"
      };

      if (config && (config.type || config.year)) {
        if (!config.type) {
          Reflect.deleteProperty(config, "type");
        }
        if (!config.year) {
          Reflect.deleteProperty(config, "year");
        }
        if (!config.update) {
          Reflect.deleteProperty(config, "update");
        }
        request.params = config;
      }

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "assignIds",
    value: function assignIds(config) {
      var request = {
        url: this._appConfig.api + "/applications/assignIds",
        method: "GET"
      };

      if (config) {
        request.params = config;
      }

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "sendAllIds",
    value: function sendAllIds(config) {
      var request = {
        url: this._appConfig.api + "/applications/sendAllIds",
        method: "GET"
      };

      if (config) {
        request.params = config;
      }

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }, {
    key: "sendId",
    value: function sendId(id) {
      var request = {
        url: this._appConfig.api + "/applications/sendId/" + id,
        method: "GET"
      };

      return this._$http(request).then(function (res) {
        return res.data;
      });
    }
  }]);

  return Applications;
}();

exports.default = Applications;


// WEBPACK FOOTER //
// ./client/components/services/applications.service.js